import { Button, Card, Placeholder, VSpacing } from '@hh.ru/magritte-ui';
import { SPALink } from '@hh.ru/redux-spa-middleware';
import { TranslatedComponent } from 'bloko/common/hooks/useTranslations';

import translation from 'src/components/translation';
import { useSelector } from 'src/hooks/useSelector';

const TrlKeys = {
    temporaryError: 'vacancySearchResults.temporaryError',
    tryAgain: 'vacancySearchResults.tryAgain',
    title: 'vacancySearchResults.error.title',
    description: 'vacancySearchResults.error.description',
    button: 'vacancySearchResults.error.button',
};

const VacancySearchError: TranslatedComponent = ({ trls }) => {
    const url = useSelector((state) => state.request.url);

    return (
        <>
            <VSpacing default={24} />
            <Card padding={16} borderRadius={24} borderWidth="default" stretched>
                <Placeholder
                    title={trls[TrlKeys.title]}
                    description={trls[TrlKeys.description]}
                    buttonPrimary={
                        <Button mode="secondary" style="accent" Element={SPALink} to={url}>
                            {trls[TrlKeys.button]}
                        </Button>
                    }
                    showButtons
                />
            </Card>
        </>
    );
};

export default translation(VacancySearchError);
